module.exports = __webpack_public_path__ + "static/vis-reg-diff-2-6ec81be515addc2e365fcb0e725da9ff.png";